import { IRoomRectangle, ToolType } from "../../types/Floorplan.types";

export interface IFloorRects {
    floorplanRectangles?: IRoomRectangle[];
    selectedFloorIdx?: number;
    selectedTool?: ToolType;
    selectedObjects?: Record<string, number[]>;
    children?: JSX.Element;
}

const FloorRects = (props: IFloorRects) => {
    const { floorplanRectangles, selectedFloorIdx, selectedTool } = props;
    return (
        <g id="floorplan">
            { floorplanRectangles && floorplanRectangles.length > 0 && floorplanRectangles.map((floor, idx) => {
                let className = "floor floor-" + idx;
                let transform: string | undefined = undefined;
                if (selectedTool === "Pointer" && (selectedFloorIdx === idx || (props.selectedObjects && props.selectedObjects.floorplanRectangles.includes(idx)))) {
                    className = "draggable draggableFloor-" + idx;
                }
                if (floor.rotation !== 0) {
                    const originX = floor.width! / 2;
                    const originY = floor.height! / 2;
                    transform = `rotate(${floor.rotation}, ${originX}, ${originY})`;
                }   

                return (    
                    <svg className={className} key={`fp_${idx}`} data-idx={idx} x={floor.x} y={floor.y} overflow="visible">
                        <g transform={transform}>
                            <rect x="0" y="0" width={floor.width} height={floor.height} stroke="none" fill="white" />
                        </g>
                    </svg>
                );
            })}
            { props.children }
        </g>
    );
};

export default FloorRects;